import { render, staticRenderFns } from "./assignBusRouteStudent.vue?vue&type=template&id=43f8a888"
import script from "./assignBusRouteStudent.vue?vue&type=script&lang=js"
export * from "./assignBusRouteStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports